// Demo environment
import packageInfo from '../../../package.json';
import { documentationUrls } from './documentation-urls';

export const environment = {
  environment: 'demo',
  production: true,
  devMode: false, //disables annoying features like lockscreen while developing
  ssoAllowed: false, // only available on staging & production

  version: packageInfo?.version,

  authAppURL: 'https://logindemo.reconcept.nl',
  authApiURL: 'https://api.portfoliodemo.reconcept.nl',

  portfolioClientName: 'APOLLO_PORTFOLIO',
  portfolioAppURL: 'https://portfoliodemo.reconcept.nl',
  portfolioApiURL: 'https://api.portfoliodemo.reconcept.nl/graphql',

  aiApiUrl: 'https://api.aidemo.reconcept.nl/api/ai',

  workspaceAppURL: 'https://workspacedemo.reconcept.nl',
  workspaceApiURL: 'https://api.portfoliodemo.reconcept.nl/graphql',

  ...documentationUrls,

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept Demo',
  otpBannerEnabled: false,

  environmentIndicator: {
    color: 'green',
    text: `Demo`,
    icon: 'times',
  },
};
